<template>
  <section  class="title is-size-5">
    <h5 class="mb-2">{{ $tc('suggestion', 2) }}</h5>
    <loading-icon v-if="isLoading" 
                  style="height: 15vh; width: 100%;"/>
    <virtual-list v-else
                  :data-sources="partSuggestionsWithQuantity"
                  :data-component="BomCartSuggestion"
                  :extra-props="{ isWidget }"
                  :keeps="200"
                  :style="scroll"
                  data-key="id"
                  ref="virtualList"
                  wrap-class="mt-4"
                  @tobottom="getMore"/>
  </section>
</template>

<script setup lang="ts">
import { computed, provide, onUnmounted } from "vue"
import { useStore } from "vuex"
import VirtualList from "vue3-virtual-scroll-list"
import BomCartSuggestion from "./BomCartSuggestion.vue"
import LoadingIcon from "@/components/common/LoadingIcon.vue"

const store = useStore()

const scroll = `
  max-height: 40vh;
  overflow-y: 'scroll';
  overflow-x: hidden;
`

const partSuggestionsWithQuantity = computed(() => {
  return store.getters["content/cartSuggestionsWithQuantity"]
})
const isLoading = computed(() => {
  return store.state.content.bom.cartSuggestions.isLoading
})
const isWidget = computed(() => {
  return store.getters["widgets/isWidget"]
})

provide(
  "partSuggestionQuantity", 
  { updatePartSuggestionQuantity }
)
function updatePartSuggestionQuantity(
  partId: number, 
  quantity: number
) {
  store.dispatch("content/updateCartSuggestionQuantity", {
    partId,
    quantity
  })
}

async function getMore() {
  await store.dispatch("content/getMoreCartSuggestions")
}

onUnmounted(() => {
  store.dispatch("content/clearCartSuggestions")
})
</script>